export default "__VITE_ASSET__d22e9639__"